import { createURL, getInitialURL, parseInitialURLAsync } from 'expo-linking';

import { CONFIG } from '../../../../launch-darkly.config';

import type { QueryParams } from 'expo-linking/src/Linking.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the initial URL without feature flag overrides query params.
 */
export async function getInitialUrlWithoutFeatureFlagsOverrides(): Promise<string | undefined> {
  try {
    const url = await getInitialURL();

    if (!url) return;

    const initialURL = await parseInitialURLAsync();

    const { path, scheme, queryParams } = initialURL;

    const isUrlWithoutQueryParams = queryParams === null || path === null;

    // ─────────────────────────────────────────────────────────────────────

    if (isUrlWithoutQueryParams) {
      return url;
    }

    if (isUrlWithoutQueryParams) {
      return;
    }

    // ─────────────────────────────────────────────────────────────────────

    const filteredQueryParams = filterQueryParams(queryParams);

    if (scheme) {
      return createURL(path, { scheme, queryParams: filteredQueryParams });
    }

    return createURL(path, { queryParams: filteredQueryParams });
  } catch {
    return undefined;
  }
}

// ─────────────────────────────────────────────────────────────────────────────

function filterQueryParams(queryParams: QueryParams): QueryParams {
  const queryParamsEntries = Object.entries(queryParams);

  return queryParamsEntries.reduce((filteredEntries, [key, value]) => {
    const shouldFilterQueryParam = key.startsWith(CONFIG.FEATURE_FLAG_OVERRIDE_QUERY_PARAM_PREFIX);

    if (shouldFilterQueryParam) {
      return filteredEntries;
    }

    return { ...filteredEntries, [key]: value };
  }, {});
}
